import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikSelect } from 'components/UiKit/FormikFields';
import { soilTypes } from '../DataSets';

const SoilType = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikSelect
      id="soil"
      name="soil"
      items={soilTypes}
      label="Soil Type"
      placeholder="Select soil type"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default SoilType;
